<section
    hideOnScroll
    [showIfNoScrollDelay]="showIfNoScrollDelay"
    [lastPageYOffset]="lastPageYOffset"
    class="category-tool-wrap"
    [ngClass]="{
        'is-rtl': isRtl$ | async
    }"
>
    <div setHeightStyleDirective="--category-tool-bar-height">
        <div class="row">
            <div class="col-xs-12">
                <div class="category-container">
                    <div class="sm:reverse">
                        <div class="category-tool-categories">
                            <category-sub-categories-selector
                                [isRtl$]="isRtl$"
                                [category]="category"
                                [selectGridView]="selectGridView"
                                [filters]="filters"
                                [filterTypeUsed]="filterTypeUsed"
                                [currentCategory]="currentCategory"
                                (updateFilterEmitter)="updateFilter($event)"
                                (categoryNameInfoEmitter)="updateCategoryNameInfo($event)"
                            >
                            </category-sub-categories-selector>
                        </div>
                    </div>
                    <div class="category-tool-badget px-32" *ngIf="isFilterApplied && showFilter">
                        <ng-content select="[categoryFilterBadge]" ngProjectAs="[categoryFilterBadge]"></ng-content>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div
    hideOnScroll
    [showIfNoScrollDelay]="showIfNoScrollDelay"
    [lastPageYOffset]="lastPageYOffset"
    class="category-tool-wrap category-tool-wrap-layer"
></div>
